import { render, staticRenderFns } from "./WitAiInfo.vue?vue&type=template&id=3494b1fb&"
import script from "./WitAiInfo.vue?vue&type=script&lang=js&"
export * from "./WitAiInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports